/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Chat_Share_Modal_Public_LabelInputs */

const es_chat_share_modal_public_label = /** @type {(inputs: Chat_Share_Modal_Public_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La conversación ahora es pública`)
};

const en_chat_share_modal_public_label = /** @type {(inputs: Chat_Share_Modal_Public_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conversation is now public`)
};

/**
* | output |
* | --- |
* | "Conversation is now public" |
*
* @param {Chat_Share_Modal_Public_LabelInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const chat_share_modal_public_label = /** @type {((inputs?: Chat_Share_Modal_Public_LabelInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Chat_Share_Modal_Public_LabelInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_chat_share_modal_public_label(inputs)
	return en_chat_share_modal_public_label(inputs)
});
export { chat_share_modal_public_label as "chat.share_modal.public_label" }